<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="Uitstelverzoek details"
>
  <snelstart-ui-details-content>
    <snelstart-venture-fiscaal-uitstel [id]="id"></snelstart-venture-fiscaal-uitstel>
  </snelstart-ui-details-content>

  <snelstart-ui-details-buttons>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="this.isIb"
                         [config]="configSave()">Opslaan
    </snelstart-ui-button>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="!this.isAangevraagd"
                         [config]="configRemove()">Afmelden
    </snelstart-ui-button>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="this.uitstelGegevens.motivatieBijzonderUitstel === undefined || this.uitstelGegevens.motivatieBijzonderUitstel.length < 10"
                         [config]="configMore()">Aanvullend uitstel
    </snelstart-ui-button>
  </snelstart-ui-details-buttons>

</snelstart-ui-details>
